const roleOrder = [
	"basic",
	"extended_access",
	"cca",
	"analyst",
	"prospector",
	"broker",
	"coordinator",
	"super_admin",
	"debugger",
]

export function sortRoles<T extends { name: string }>(roles: T[]): T[] {
	return [...roles].sort((a, b) => {
		const roleAIndex = roleOrder.indexOf(a.name)
		const roleBIndex = roleOrder.indexOf(b.name)
		if (roleAIndex === -1 && roleBIndex === -1) return a.name.localeCompare(b.name)
		if (roleAIndex === -1) return 1
		if (roleBIndex === -1) return -1
		return roleAIndex - roleBIndex
	})
}

export function formatRoleName(name: string): string {
	if (name.toLowerCase() === "cca") return "CCA"
	return name
		.split("_")
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ")
}
